import React, { useState, useRef, useEffect } from "react";
import { Container, Input, Form, FormGroup, Label, Button,Col,Row} from "reactstrap";
import challenge_icon from "../../../assets/Icons/challenge_icon.png";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate,useLocation } from "react-router-dom";
import whiteLogo from "../../../assets/logos/White on Transparent.png";
import "../Login.css";
import { Link } from "react-router-dom";
import { handleUpdatePassword } from "../../../store/actions/authAction";
function ForgetPasswordUpdate() {
    const [password, setPassword] = useState("");
    const [confirmPassword, setConfirmPassword] = useState("");
    const [isRegisterationCompleted,setRegisterationCompleted] = useState(false)
    const [error,setError] = useState("")
    var appInfo = useSelector((state) => state.appInfo);
    const location  = useLocation();
    useEffect(()=>{
        if(!location?.state?.phoneNumber){
           navigate("/mobile-forget-password")
        }
       },[])
        const [windowSize, setWindowSize] = useState({
        width: window.innerWidth,
        height: window.innerHeight
      });
    useEffect(() => {
        const handleResize = () => {
          setWindowSize({
            width: window.innerWidth,
            height: window.innerHeight
          });
        };
      
        window.addEventListener('resize', handleResize);
    
        return () => {
          window.removeEventListener('resize', handleResize);
        };
      }, []);
       useEffect(()=>{
        if(windowSize.width>=778){
            navigate("/auth");
        }

      },[windowSize.width])
    const phoneNumber  =location?.state?.phoneNumber;
    console.log(phoneNumber)
    const dispatch = useDispatch();
    const timer = useRef();  
    const navigate= useNavigate()
    const resetError = () => {
        setError("");
        clearTimeout(timer);
      };
      const handleClick = () => {
       navigate("/mobile-auth")
      };
      const updatePassword = () => {
        // setappInfo.loading(true);

        console.log("function login called");
        if (password === null || confirmPassword === null) {
            setError("*Please Fill All the Fields!!");
            timer.current = setTimeout(resetError, 1500);
          // setappInfo.loading(false); 
        } else if (password !== confirmPassword) {
          setError("*Password didn't match!!");
          timer.current = setTimeout(resetError, 1500);
        } else {
          let data = {
            
            phoneNumber: phoneNumber,
            password: password,
          };
          dispatch(
            handleUpdatePassword(data, (args) => {
              console.log("ARGS->", args);
              setRegisterationCompleted(true)
            })
          );
        }
    }
  return (
    <Container className="bgImg">
         <Row>
        <center>
            <Link to="/">
              <img style={{ width: 250,marginBottom:20,marginTop:40 }} src={whiteLogo} />
            </Link>
          </center>
        </Row>    
    <Row  style={{
             marginTop: 10,
             height:380,
             background: "rgba(216,216,216,0.48)",
             boxShadow: "0 4px 30px rgba(0, 0, 0, 0.1)",
             borderRadius: 5,
             backdropFilter: "blur(5px)",
             padding: 20,
             margin:5,
        }}>
        <Col md="10">
        {
    isRegisterationCompleted ? (
              <center>
                <div>
                  <img style={{ width: 130 }} src={challenge_icon} />
                  <p
                    style={{
                      color: "#094709",
                      fontSize: 18,
                      marginTop: 10,
                      marginLeft: 15,
                    }}
                  >
                    Your password is updated!!
                  </p>
                  <Button
                    className="submitButton"
                    style={{ marginTop: 10 }}
                    onClick={()=>handleClick()}
                  >
                    Sign In Now
                  </Button>
                </div>
              </center>
            ) :
        <Form>
            <FormGroup>
              <Input
                className="inputBox"
                onChange={(e) => setPassword(e.target.value)}
                style={{ marginTop: 35 }}
                placeholder="Please Enter Password"
                autoComplete="off"
                value={password}
              />
               <Input
                className="inputBox"
                onChange={(e) => setConfirmPassword(e.target.value)}
                style={{ marginTop: 35 }}
                placeholder="Please Confirm Password"
                autoComplete="off"
                type="password"
                value={confirmPassword}
              />
            </FormGroup>
            <center>

            <Button
              className="submitButton"
              style={{ marginTop: 32 }}
              onClick={()=>updatePassword()}
            >
              {
                appInfo.loading?"Loading..." : "Update Password"
              }
               
            </Button>

            {error !== "" ? (
                <p style={{ color: "#9e1212", marginTop: 10 }}>{error}</p>
                ) : null}
            </center>
            <center>

            <Button
              className="submitButton"
              style={{ marginTop: 32,color:'#76561c',background:'white',fontSize:13 }}
              onClick={()=>(navigate("/mobile-auth"))}
              >
              Signin Now
            </Button>
              </center>
          </Form>
}
        </Col>
    </Row>
</Container>
  )
}

export default ForgetPasswordUpdate